import React, { Component } from "react";
import Switch from "react-switch";

class PermissionSwitch extends Component {

     handleChange = (status,name) => {
         if(!this.props.disabled){ 
         if(status === 1){
             status = 0
         }
         else{
             status = 1;
         }
        this.props.parentCallback(status,name);
         }
    }

    switchProps = () => ({
        checked: this.props.status === 1,
        onChange: () =>
            this.handleChange(this.props.status, this.props.keyName),
        onColor: "#22c55e",
        onHandleColor: "#ffffff",
        offColor: "#cbd5e1",
        offHandleColor: "#ffffff",
        handleDiameter: 18,
        uncheckedIcon: false,
        checkedIcon: false,
        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.12)",
        activeBoxShadow: "0 0 0 2px rgba(34, 197, 94, 0.25)",
        height: 22,
        width: 44,
        className: "react-switch",
        disabled: this.props.disabled,
    });

render(){
    const switchEl = <Switch {...this.switchProps()} />;

return(
    <>
    {this.props.variant === "tile" ? (
        <div
            className={
                "permissions-tile" +
                (this.props.status === 1 ? " is-on" : "")
            }
        >
            <p className="permissions-tile-label">{this.props.text}</p>
            {switchEl}
        </div>
    ) : this.props.generic ? switchEl : (
    <div className="row">
        <div className="col-lg-6 col-9 p-2 text-left">
        <h6 className="text-muted m-b-0 font-f-monst-sans">{this.props.text}</h6></div>
        <div className="col-lg-6 col-3 p-2 text-right">
        {switchEl}
    </div>
    </div> )}
           
        </>
    )
    }
}
export default PermissionSwitch;